
<template>
  <div class="fixed">
    
    <v-alert
      app
      v-if="is_on_trial_or_expired && is_trial_done"
      type="error"
      dense
      icon="mdi-alert-octagon-outline"
    >
      <v-row class="px-1" align='center' justify='space-between'>

        <span>
          <strong>Período de testes acabou.</strong> 
          Para continuar usando o Checkbits, assine agora!
        </span>
        <v-btn small color="white" class="black--text" @click="goToPlansPage">Planos</v-btn>

      </v-row>
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  components: {
  },
  data() {
    return {
      msg: "Funcionalidade limitada",
    };
  },
  methods: {
    goToPlansPage(){
      window.open(
        "https://checkbits.com.br/planos",
        "_blank"
      );
    },
  },
  computed: {
    is_on_trial_or_expired(){
      if (this.company_data){
        if (['on_trial', 'trial_expired'].includes(this.company_data.status)){
          return true
        }
      }
      return false
    },
    is_trial_done(){
      let days = 0 
      if (this.company_data.trial && this.company_data.trial.end_date){
        days = this.$moment(this.company_data.trial.end_date).diff(this.$moment(), 'days', false)
      } else if(this.company_data.trial) {
        days = this.$moment().diff(this.$moment(this.company_data.created_at), 'days', false)
        days = this.company_data.trial.days_duration - days
      } else if (!this.company_data.trial && this.is_on_trial_or_expired){
        days = this.$moment().diff(this.$moment(this.company_data.created_at), 'days', false)
        days = 7 - days
      }

      return days < 0
    },
    company_data() {
      if (this.oneUser && this.oneUser.company){
        return this.oneUser.company.data.attributes
      }
      return null 
    },
    ...mapState({
      oneUser: state => state.User.oneUser,
      // token_access_token: state => state.User.token_access_token,
      allSolutions: state => state.Solution.allSolutions,
      loading_solutions: state => state.Solution.loading_solutions
    })
  },
  watch: {
    
  },
};
</script>

<style scoped>
.fixed {
  position: relative;
  width: 100%;
  z-index: 1;
}
</style>
